var map = {
  "./cs.messages.tsx": [
    "21479",
    [
      6650
    ]
  ],
  "./en.messages.tsx": [
    "88834",
    [
      5181
    ]
  ],
  "./sl.messages.tsx": [
    "30374",
    [
      9065
    ]
  ],
  "./hu.messages.tsx": [
    "64030",
    [
      8257
    ]
  ],
  "./de.messages.tsx": [
    "87149",
    [
      2773
    ]
  ],
  "./it.messages.tsx": [
    "30560",
    [
      8887
    ]
  ],
  "./pl.messages.tsx": [
    "55833",
    [
      9800
    ]
  ],
  "./sk.messages.tsx": [
    "99775",
    [
      4546
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 65886;
module.exports = __rspack_async_context;
